/**
 * SOGI CRM — version centrale.
 *
 * À mettre à jour à chaque release. Suivre semver :
 *   - MAJOR : breaking change (refonte UI majeure, migration DB obligatoire)
 *   - MINOR : nouvelle fonctionnalité non-breaking
 *   - PATCH : bug fix uniquement
 *
 * Cette constante est affichée dans la sidebar et le centre d'aide.
 */
export const APP_VERSION = "2.8.15";
export const APP_VERSION_DATE = "2026-06-02";
export const APP_NAME = "SOGI CRM";
